import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;


const FETCH_MEMBERS_REQUEST = 'Foundation/myteams/FETCH_MEMBERS_REQUEST';
const FETCH_MEMBERS_SUCCESS = 'Foundation/myteams/FETCH_MEMBERS_SUCCESS';
const FETCH_MEMBERS_FAIL = 'Foundation/myteams/FETCH_MEMBERS_FAIL';

export default function memberReducer(state = {
  datas: [],
  pageMeta: {},
  isLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_MEMBERS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_MEMBERS_SUCCESS:
      {
        const {
          data,
          meta: {
            pageNumber,
            pageSize,
            pageCount,
          },
        } = action.response;
        const maxPage = Math.ceil(pageCount / pageSize);
        const pageMeta = {
          maxPage,
          currentPage: pageNumber,
          perPage: pageSize,
          total: pageCount,
        };
        return Object.assign({}, state, {
          pageMeta,
          isLoading: false,
          datas: data,
        });
      }
    case FETCH_MEMBERS_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
      });
    default:
      return state;
  }
}

export function getDirectMembers(params) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'departments/directmemebers',
      method: 'GET',
      params: {
        PageSize: 8,
        PageNumber: params.pageNumber,
        keyword: params.keyword,
      },
      types: [
        FETCH_MEMBERS_REQUEST,
        FETCH_MEMBERS_SUCCESS,
        FETCH_MEMBERS_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyTeams/reducers/memberReducer.js
 **/